import { h } from 'preact'
import { useContext } from 'preact/hooks'
import styled from 'styled-components'
import { Context } from '../context/Context'
import { Actions, Views } from '../../enums'

// Sort of a one off style for these, so we'll just keep them here
const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
`
const Link = styled.div`
  margin-top: 10px;
  margin-right: auto;
  margin-bottom: 10px;
  margin-left: auto;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: inherit;
  background: none;
  border: none;
  &:active,
  &:focus,
  &:focus-within,
  &:hover {
    color: inherit;
    background: none;
    cursor: pointer;
  }
`

const PrivacySettingsLink = () => {
  const globalState = useContext(Context)
  const { state, dispatch } = globalState

  const handleClick = () => dispatch({ type: Actions.settings })

  return !state.loading ? (
    <LinkContainer>
      <Link
        id='mv_privacy_settings'
        onClick={handleClick}
      >
        { state.copy[Views.privacySettingsLink] }
      </Link>
    </LinkContainer>
  ) : null
}

export default PrivacySettingsLink
